// Country helpers. A user's country is stored on users/{uid}.country as an ISO 3166-1 alpha-2
// code ("IN", "US", ...) and is refreshed from the visitor's IP by /api/geo.

const UNKNOWN = new Set(['XX', 'ZZ'])

/** "in" / " IN " -> "IN". Anything that is not a real 2-letter code -> null. */
export const normalizeCountry = (code: unknown): string | null => {
  const c = typeof code === 'string' ? code.trim().toUpperCase() : ''
  return /^[A-Z]{2}$/.test(c) && !UNKNOWN.has(c) ? c : null
}

/** "IN" -> "India" (shown as the flag's tooltip). */
export function countryName(code: string): string {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || code
  } catch {
    return code
  }
}
